import React from 'react';
import {
  BorderWrapper,
  FlexRow,
  CategoryLabel,
  SectionHeader,
  RequiredLabel,
} from 'components/styled-components';
import {
  InputGroup,
  NumericInput,
  Switch,
  Icon,
  Tooltip,
} from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import Select from 'react-select';
import ErrorWrapper from 'components/forms/components/error-wrapper';

export const QuestionDetails = ({
  questionTypes,
  categories,
  weight,
  category,
  questionType,
  controlID,
  defaultQuestion,
  handleQuestionTypeChange,
  handleWeightChange,
  handleCategoryChange,
  handleControlIDChange,
  handleDefaultChange,
  ...rest
}) => (
  <BorderWrapper padding="1rem">
    <SectionHeader>Details</SectionHeader>
    <FlexRow width="80%" justify="flex-start">
      <div style={{ width: '35%', marginRight: '3rem' }}>
        {rest.typeError && (
          <ErrorWrapper>A question must have a type.</ErrorWrapper>
        )}
        <CategoryLabel>
          Question Type <RequiredLabel>(required)</RequiredLabel>
          <Tooltip content="* Denotes that a question type is mandatory. These questionnaire sections cannot be bypassed via opt-out.">
            <Icon icon={IconNames.INFO_SIGN} style={{ marginLeft: 5 }} />
          </Tooltip>
        </CategoryLabel>
        <Select
          options={questionTypes}
          value={questionType}
          getOptionLabel={option =>
            option.mandatory ? `${option.typeName} *` : option.typeName
          }
          getOptionValue={option => option.typeID}
          onChange={handleQuestionTypeChange}
        />
      </div>
      <div style={{ marginRight: '3rem' }}>
        {rest.controlError && (
          <ErrorWrapper>The control number cannot be blank</ErrorWrapper>
        )}
        <CategoryLabel>
          Control Number <RequiredLabel>(required)</RequiredLabel>
        </CategoryLabel>
        <InputGroup value={controlID} onChange={handleControlIDChange} />
      </div>
      <div>
        <CategoryLabel>Default</CategoryLabel>
        <Switch
          large
          checked={defaultQuestion}
          onChange={() => handleDefaultChange(!defaultQuestion)}
        />
      </div>
    </FlexRow>
    <FlexRow width="80%" padding="1rem 0" justify="flex-start">
      <div style={{ width: '45%', marginRight: '3rem' }}>
        {rest.categoryError && (
          <ErrorWrapper>
            A question must have at least one category
          </ErrorWrapper>
        )}
        <CategoryLabel>
          Display Category <RequiredLabel>(required)</RequiredLabel>
        </CategoryLabel>

        <Select
          options={categories}
          value={category}
          getOptionLabel={option => option.categoryName}
          getOptionValue={option => option.categoryID}
          onChange={handleCategoryChange}
        />
      </div>
      <div>
        {rest.weightError && (
          <ErrorWrapper>The weight cannot be blank</ErrorWrapper>
        )}
        <CategoryLabel>
          Weight <RequiredLabel>(required)</RequiredLabel>
        </CategoryLabel>
        <NumericInput
          value={weight}
          onValueChange={handleWeightChange}
          required={true}
          min={1}
        />
      </div>
    </FlexRow>
  </BorderWrapper>
);
